export const environment = {
  fleetApiUrl: 'https://qs-fleethub-dev.azurewebsites.net/api'
};

